<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">[{{ mode }}] Work Matrix Approver </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="p-grid p-field">
                                    <div class="p-row">
                                        <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.CreatedDate) }}
                                    </div>
                                    <div class="p-row">
                                        by {{ header.CreatedBy }}
                                    </div>
                                </div>
                                <div class="p-grid p-field" v-if="header.EditedDate">
                                    <div class="p-row">
                                        <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.EditedDate) }}
                                    </div>
                                    <div class="p-row">
                                        by {{ header.EditedBy }}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-save" label="Save" class="p-button-success" @click="confirm($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW
                            " />
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirm($event)"
                            v-if="mode == this.$FORM_MODE_DELETE" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <TabView>
                        <TabPanel header="Department Detail" v-if="mode != this.$FORM_MODE_CREATE">
                            <div class="grid">
                                <div class="col-6">
                                    <div class="field grid">
                                        <label for="Code" class="col-4">{{ $t("code") }}</label>
                                        <div class="col-8 md-8">
                                            <InputText name="Location" v-model="header.Code" required="true" type="text"
                                                :placeholder="$t('code')" v-if="header"
                                                :class="{ 'p-invalid': submitted && !header.Code }" :disabled="true" />
                                            <small v-if="header &&
                                                !header.Code &&
                                                submitted &&
                                                mode != this.$FORM_MODE_DELETE
                                                " class="p-error">{{ $t("is_required").replace("Value", $t("desc")) }}
                                            </small>
                                            <Skeleton v-else-if="!header" />
                                        </div>
                                    </div>
                                    <div class="field grid">
                                        <label for="Name" class="col-4">{{ $t("name") }}</label>
                                        <div class="col-8 md-8">
                                            <InputText name="Name" v-model="header.Name" required="true" type="text"
                                                :placeholder="$t('name')" v-if="header"
                                                :class="{ 'p-invalid': submitted && !header.Name }" :disabled="true" />
                                            <small v-if="header &&
                                                !header.Name &&
                                                submitted &&
                                                mode != this.$FORM_MODE_DELETE
                                                " class="p-error">{{ $t("is_required").replace("Value", $t("name")) }}
                                            </small>
                                            <Skeleton v-else-if="!header" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12" style="margin-top:100px">
                                <WorkRole :dataArray="header.CompanyWorkMatrix" :dataModel="workrolemodel" v-if="header"
                                    :header="header" :mode="mode" />
                            </div>

                        </TabPanel>
                        <!-- <TabPanel header="Work Role" v-if="mode != this.$FORM_MODE_CREATE">
                            <WorkRole :dataArray="header.CompanyWorkMatrix" :dataModel="workrolemodel" v-if="header"
                                :header="header" :mode="mode" />
                        </TabPanel> -->
                        <TabPanel header="Maintenance Role" v-if="mode != this.$FORM_MODE_CREATE">
                            <MaintenanceRole :dataArray="header.MtcApproval" :dataModel="mtcrolemodel" v-if="header"
                                :header="header" :mode="mode" />
                        </TabPanel>
                    </TabView>
                </div>
            </template>
        </Card>
    </form>
</template>
    
    
<script>
import MaintenanceRole from './_MaintenanceRole.vue';
import WorkRole from './_WorkRole.vue';

export default {
    name: "Editor",
    components: {
        MaintenanceRole: MaintenanceRole,
        WorkRole: WorkRole
    },
    data() {
        return {
            indexName: "WorkMatrixIndex",
            url: this.$API_URL + "workmatrix/",
            header: null,
            workrolemodel: null,
            mtcrolemodel: null,
            mode: "",
            submitted: false,
            id: 0,
            formEditable: true,
        };
    },
    methods: {
        getData() {
            var self = this;
            this.$axios
                .get(this.url + this.id + "/" + this.mode)
                .then((response) => {

                    self.header = response.data.data.header;
                    self.header.mode = self.mode;
                    self.workrolemodel = response.data.data.companyworkmatrix;
                    self.mtcrolemodel = response.data.data.mtcapproval;

                    //console.log(self.header);

                })
                .catch(function (error) {
                    alert(error);
                });
        },
        saveData() {
            this.$emit("block-ui");
            var self = this;
            this.$axios
                .post(this.url, this.header)
                .then((response) => {
                    if (response.data.success) {
                        if (this.mode == this.$FORM_MODE_DELETE) {
                            self.$router.push({
                                name: self.indexName,
                                params: {
                                    showToast: true,
                                    severity: "success",
                                    summary: "Data Deleted",
                                    detail:
                                        "Company " +
                                        self.header.Code +
                                        " has been deleted successfully",
                                    life: 3000,
                                },
                            });
                        } else {
                            self.$router.push({
                                name: self.indexName,
                                params: {
                                    showToast: true,
                                    severity: "success",
                                    summary: "Data Saved",
                                    detail:
                                        "Company " +
                                        self.header.Code +
                                        " has been saved successfully",
                                    life: 3000,
                                },
                            });
                        }
                    } else {
                        self.showError("Error Saving Data", response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError("Error Saving Data", error);
                });
        },
        showError(summary, message) {
            this.$emit("unblock-ui");
            this.$toast.add({
                severity: "error",
                summary: summary,
                detail: message,
                life: 3000,
            });
        },
        backToIndex() {
            this.$router.push({ path: "/WorkMatrix/Index" });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.submitted = true;
            this.$confirm.require({
                target: event.currentTarget,
                message: "Are you sure?",
                icon: "pi pi-exclamation-triangle",
                accept: () => {
                    this.saveData();
                },
                reject: () => { },
            });

        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? "row-hidden" : null;
        },
        addDetail() {
            var newDetail = this.detail;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.Locations.push(det);
        },
        deleteDetail(event) {
            if (event) {
                var detail = this.header.Locations[event.index];
                if (detail.mode == this.$FORM_MODE_CREATE)
                    this.header.Locations.splice(this.header.Locations.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditComplete(event) {
            this.editDetail(event.index);
        },
        editDetail(index) {
            if (this.header && this.header.Details) {
                let mode = this.header.Details[index].mode;
                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Details[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
    },
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;

        this.getData();
    },
};
</script>